 import refreshCaptcha from "../utils/captcha-refresh";

let scrmPolandPnaChangeEvent;
function main() {
    const crmForm = document.querySelector('.pp-crm-form');
    jQuery(document).ready(function( $ ) {

    let scrmSelectCountry = document.querySelector('#field_5_12 #input_5_12_6');

    //phone
    jQuery('#input_5_5').inputmask({
        mask: '',
        regex: "^[0-9]{0,100}$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    $('#field_5_12 #input_5_12_6').bind( 'change', function (e) {
        jQuery( '#input_5_10' )[0].value = null;
        jQuery( '#input_5_9' )[0].value = null;

        if(scrmPolandPnaChangeEvent) {
            document.querySelector('#input_5_9').removeEventListener('change', scrmPolandPnaChangeEvent);
        }

        if('Polska'!==scrmSelectCountry.value) {
            scrmNoPoland();
        } else {
            scrmPoland();
        }
        disableCityAndPostalCodeField(crmForm, scrmSelectCountry.value);
    });

    // Validation message email field
    if(!document.querySelector('#validation_message_5_3')) {
        document.querySelector('#input_5_3').parentNode.innerHTML += '<div id="validation_message_5_3" class="gfield_description validation_message gfield_validation_message d-none">Drogi kliencie wyraziłeś zgodę na przesłanie informacji handlowej. Abyśmy mogli przesłać Ci ofertę handlową podaj swój adres email.</div>'
    }
    $('#input_5_3').on( 'change', function(e) {
        if(document.querySelector('#choice_5_30_1').checked){
            if(e.target.value.includes('@')) {
                document.querySelector('#validation_message_5_3').classList.add('d-none');
                document.querySelector('#field_5_3').classList.remove('gfield_error');
                document.querySelector('#input_5_3').setAttribute('aria-invalid', 'false');
            }else {
                document.querySelector('#validation_message_5_3').classList.remove('d-none');
                document.querySelector('#field_5_3').classList.add('gfield_error');
                document.querySelector('#input_5_3').setAttribute('aria-invalid', 'true');
            }
        }
    });

    // Mark when phone field should be required
    if(!document.querySelector('#validation_message_5_5')) {
        document.querySelector('#input_5_5').parentNode.innerHTML += '<div id="validation_message_5_5" class="gfield_description validation_message gfield_validation_message d-none">Drogi kliencie wyraziłeś zgodę na przesłanie informacji handlowej. Abyśmy mogli przesłać Ci ofertę handlową podaj swój nr telefonu.</div>'
    }
    $('#input_5_5').on( 'change', function(e) {
        if(document.querySelector('#choice_5_29_1').checked) {

            if(e.target.value.length > 0) {
                document.querySelector('#validation_message_5_5').classList.add('d-none');
                document.querySelector('#field_5_5').classList.remove('gfield_error');
                document.querySelector('#input_5_5').setAttribute('aria-invalid', 'false');
            }else {
                document.querySelector('#validation_message_5_5').classList.remove('d-none');
                document.querySelector('#field_5_5').classList.add('gfield_error');
                document.querySelector('#input_5_5').setAttribute('aria-invalid', 'true');
            }

            // Remove/add error from phone field based on value
            if(e.target.value) {
                document.querySelector('#field_5_5').classList.remove('gfield_error');
                document.querySelector('#input_5_5').setAttribute('aria-invalid', 'false');
            }else {
                document.querySelector('#field_5_5').classList.add('gfield_error');
                document.querySelector('#input_5_5').setAttribute('aria-invalid', 'true');
            }
        } else {
            // Require consent 2 if consent 1 is not set and phone has value
            if(e.target.value && !document.querySelector('#choice_5_30_1').checked) {
                document.querySelector('#field_5_29').classList.add('gfield_error');
            }
            // Do not require consent 2 if consent 1 is set and phone has value
            if(e.target.value && document.querySelector('#choice_5_30_1').checked){
                document.querySelector('#field_5_29').classList.remove('gfield_error');
            }
            // Do not require consent 2 if email is set and phone has value
            // if(e.target.value && document.querySelector('#input_5_3').value) {
            //     document.querySelector('#field_5_29').classList.remove('gfield_error');
            // }
            // Do not require consent 2 if phone is empty
            if(!e.target.value) {
                document.querySelector('#field_5_29').classList.remove('gfield_error');
            }
        }
    });

    // First consent
    $('#input_5_30').on('click', function (e) {
            if(document.querySelector('#validation_message_5_3')) {
                if(e.target.checked){
                    // Require email field if empty
                    if (!document.querySelector('#input_5_3').value){
                        document.querySelector('#validation_message_5_3').classList.remove('d-none');
                        document.querySelector('#field_5_3').classList.add('gfield_error');
                        document.querySelector('#input_5_3').setAttribute('aria-invalid', 'true');
                        document.querySelector('#field_5_3').scrollIntoView({behavior:'smooth'});
                    }

                    //Do not require phone field
                    document.querySelector('#field_5_5').classList.remove('gfield_error');
                    document.querySelector('#input_5_5').setAttribute('aria-invalid', 'false');

                    //Do not require second consent
                    document.querySelector('#field_5_29').classList.remove('gfield_error');
                } else {
                    // Do not display email validation message
                    document.querySelector('#validation_message_5_3').classList.add('d-none');
                    document.querySelector('#field_5_3').classList.remove('gfield_error');
                    document.querySelector('#input_5_3').setAttribute('aria-invalid', 'false');

                    // Mark 2 consent as required if phone is set
                    if(document.querySelector('#input_5_5').value && !document.querySelector('#choice_5_29_1').checked){
                        document.querySelector('#field_5_29').classList.add('gfield_error');
                    }
                    // Mark phone field as required if it is empty and second consent is checked
                    if(!document.querySelector('#input_5_5').value && document.querySelector('#choice_5_29_1').checked){
                        document.querySelector('#field_5_5').classList.add('gfield_error');
                        document.querySelector('#input_5_5').setAttribute('aria-invalid', 'true');
                    }
                }
            }
        });

    // Second consent
    $('#input_5_29').on('click', function (e) {
            if(e.target.checked){
                // Require phone field if empty
                if(!document.querySelector('#input_5_5').value){
                    document.querySelector('#field_5_5').classList.add('gfield_error');
                    document.querySelector('#input_5_5').setAttribute('aria-invalid', 'true');
                    document.querySelector('#field_5_5').scrollIntoView({behavior:'smooth'});
                }
            } else {
                document.querySelector('#field_5_5').classList.remove('gfield_error');
                document.querySelector('#input_5_5').setAttribute('aria-invalid', 'false');

                // Mark 2 consent as required if phone is set and email is empty
                if(document.querySelector('#input_5_5').value && !document.querySelector('#choice_5_29_1').checked){
                    document.querySelector('#field_5_29').classList.add('gfield_error');
                }

                // Do not require 2 consent if phone is empty
                if(!document.querySelector('#input_5_5').value){
                    document.querySelector('#field_5_29').classList.remove('gfield_error');
                }
            }
    });

    // Add autocomplete to postal code field
    let tabPressFunction;
    $( '#input_5_9' ).autocomplete({
        source: '/wp-content/themes/pp/inc/crm-form/scrm-search-pna.php',
        minLength: 2,
        select: function( event, ui ) {
            if(ui.item.id !== '0') {
                zamiana(scrmSelectCountry.value,ui.item);
            }
        },
        response: function (event, ui) {
            if(tabPressFunction) {
                event.target.removeEventListener('keydown', tabPressFunction);
            }

            if(ui.content.length === 1 && ui.content[0].id !== '0') {
                tabPressFunction = (e) => addTabPressEvent(e);
                event.target.addEventListener('keydown', tabPressFunction);

                function addTabPressEvent(e){
                    if (e.keyCode === 9 && scrmSelectCountry.value === "Polska") {
                        event.target.value = ui.content[0].value;
                        zamiana(scrmSelectCountry.value, ui.content[0]);
                    }
                }
            }
        },
    }).data("ui-autocomplete")._renderItem = function (ul, item) {
        if(item.id === '0'){
            return $('<li class="ui-state-disabled">'+item.label+'</li>').appendTo(ul);
        }else{
            return $("<li>")
                .append("<div>" + item.label + "</div>")
                .appendTo(ul);
        }
    };

    if(scrmPolandPnaChangeEvent) {
        document.querySelector('#input_5_9').removeEventListener('change', scrmPolandPnaChangeEvent);
    }

    if('Polska'!==scrmSelectCountry.value){
        scrmNoPoland();
    } else {
        scrmPoland();
    }
    disableCityAndPostalCodeField(crmForm, scrmSelectCountry.value);

    });//jQuery.document.ready
}

document.addEventListener('DOMContentLoaded', ()=> {
    if(document.querySelector('#gform_wrapper_5')){
        main();
        refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');
    }
});
jQuery(document).on('gform_post_render', function(){

    if(document.querySelector('#gform_wrapper_5')){
        main();
        refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');
    }

});

function zamiana(country,ui) {
    let data = new FormData();
    let options = [];
    data.append('country', country);
    data.append('id', ui.id);
    data.append('value', ui.value);

    let url = new URL (document.URL);
    let scrmUrlCity = url.origin + '/wp-content/themes/pp/inc/crm-form/scrm-search-city.php';

    let xhr = new XMLHttpRequest();
    xhr.open('POST', scrmUrlCity, true);
    xhr.send(data);
    xhr.onload = function (){
         // console.log(xhr.response);
        let responseData = JSON.parse(xhr.responseText);
        options = responseData.options;

        const pnaField = document.querySelector('#field_5_9');
        const pnaInput = document.querySelector('#input_5_9');
        if(!options.length) {
            setInputField('');
            addPnaValidationMessage(pnaField, pnaInput);

            return;
        } else {
            removePnaValidationMessage(pnaField, pnaInput);
        }

        let scrmInputCityWrap = document.querySelector('#field_5_10 .ginput_container_text');
        let scrmHtmlCity = '';

        scrmHtmlCity += '<select class=\"form-select\" name=\"input_10\" id=\"input_5_10\" form=\"gform_5\">';

        options.forEach((element, index) => {
            if(0===index) {
                scrmHtmlCity += '<option selected=\"selected\" value=\"' + element + '\">' + element + '</option>';
            } else {
                scrmHtmlCity += '<option value=\"' + element + '\">' + element + '</option>';
            }

        });

        scrmHtmlCity += '</select>';
        scrmInputCityWrap.innerHTML = scrmHtmlCity;

    }

}//zamiana

function addPnaValidationMessage(pnaField, pnaInput) {
    pnaInput.setAttribute('aria-invalid', 'true');
    pnaField.classList.add('gfield_error');

    let validationMessage = document.createElement('div');
    validationMessage.classList.add('gfield_description', 'validation_message', 'gfield_validation_message');
    validationMessage.id = 'validation_message_5_9';
    validationMessage.innerText = 'Podany kod jest nieprawidłowy, tylko cyfry arabskie 0-9 rozdielone znakiem "-" 00-000.'
    if(!document.querySelector('#validation_message_5_9')) pnaField.appendChild(validationMessage);
}

function removePnaValidationMessage(pnaField, pnaInput) {
    pnaInput.setAttribute('aria-invalid', 'false');
    pnaField.classList.remove('gfield_error');
    document.querySelector('#validation_message_5_9')?.remove();
    document.querySelector('#validation_message_5_10')?.remove();
}

function scrmPoland() {
    //NIP
    jQuery('#input_5_7').inputmask({
        mask: '',
        regex: "^[0-9]{10}$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    // Postal code
    document.querySelector('#input_5_9').addEventListener('input', function(e){
        if('Polska'===document.querySelector('#field_5_12 #input_5_12_6').value) e.target.value = formatZipCodePL(e.target.value);
    });

    const pnaField = document.querySelector('#field_5_9');
    const pnaInput = document.querySelector('#input_5_9');
    if(!document.querySelector('#input_5_10').value && pnaInput.value) addPnaValidationMessage(pnaField, pnaInput);
    else removePnaValidationMessage(pnaField, pnaInput);

    scrmPolandPnaChangeEvent = (e) => addScrmPolandPnaChangeEvent(e);
    document.querySelector('#input_5_9')?.addEventListener('change', scrmPolandPnaChangeEvent);

    jQuery('#input_5_9').attr('maxlength', '8');
    jQuery('#input_5_9').attr('placeholder', '_ _ - _ _ _');

    setInputField();

}//scrmPoland

function addScrmPolandPnaChangeEvent(e) {
    const pnaId = e.target.value.replace(' - ', '');
    const pnaValue = e.target.value;

    if(pnaId.length === 5) {
        zamiana(document.querySelector('#field_5_12 #input_5_12_6').value, {'id': pnaId, 'label': pnaValue, 'value': pnaValue});
    } else {
        setInputField('');
    }
}

function setInputField(prevCityVal) {
    let scrmInputCityWrap = document.querySelector('#field_5_10 .ginput_container_text');
    let scrmHtmlCity = '';
    prevCityVal = prevCityVal !== '' ? convertHTML(document.querySelector('#input_5_10').value) : '';
    scrmHtmlCity = '<input name=\"input_10\" id=\"input_5_10\" type=\"text\" value=\"'+prevCityVal+'\" class=\"form-control\" maxlength=\"150\" placeholder=\"Uzupełni się automatycznie po wybraniu kodu\" aria-required=\"true\" aria-invalid=\"false\" readonly=\"\">';
    scrmInputCityWrap.innerHTML = scrmHtmlCity;

    jQuery( '#input_5_9' ).autocomplete( 'enable' );
    jQuery( '#input_5_10' ).attr('readonly','readonly');
}

function scrmNoPoland() {
    //NIP
    jQuery('#input_5_7').inputmask({
        mask: '',
        placeholder: '',
        regex: "^[a-zA-Z0-9]{0,12}$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    //Postal code
    document.querySelector('#input_5_9').addEventListener('keydown', function(e) {
        if('Polska'!==document.querySelector('#field_5_12 #input_5_12_6').value) {
            formatZipCodeNoPL(e);
        }
    });

    const pnaField = document.querySelector('#field_5_9');
    const pnaInput = document.querySelector('#input_5_9');
    removePnaValidationMessage(pnaField, pnaInput);
        // .inputmask({
        //     mask:'',
        //     placeholder:'',
        //     regex: "^[a-zA-Z0-9 -]{0,10}$",
        //     showMaskOnHover: false,
        //     showMaskOnFocus: false,
        // });
    jQuery('#input_5_9').attr('maxlength', '10');
    jQuery('#input_5_9').attr('placeholder', '_ _ _ _ _ _ _ _ _ _');

    let scrmInputCityWrap = document.querySelector('#field_5_10 .ginput_container_text');
    let scrmHtmlCity = '';
    let prevCityVal = convertHTML(document.querySelector('#input_5_10').value);
    scrmHtmlCity = '<input name=\"input_10\" id=\"input_5_10\" type=\"text\" value=\"'+prevCityVal+'\" class=\"form-control\" maxlength=\"150\" placeholder=\"Wpisz nazwę miejscowości\" aria-required=\"true\" aria-invalid=\"false\" readonly=\"\">';
    scrmInputCityWrap.innerHTML = scrmHtmlCity;

    jQuery( '#input_5_9' ).autocomplete( 'disable' );
    jQuery( '#input_5_10' ).attr('readonly',null);

}//scrmNoPoland

function disableCityAndPostalCodeField(crmForm, countryValue) {
    if (!countryValue) {
        crmForm.querySelector(`.city-field #input_5_10`).setAttribute('disabled', true);
        crmForm.querySelector(`.zip-code-field #input_5_9`).setAttribute('disabled', true);
    } else {
        crmForm.querySelector(`.city-field #input_5_10`).removeAttribute('disabled');
        crmForm.querySelector(`.zip-code-field #input_5_9`).removeAttribute('disabled');
    }
}

function formatZipCodePL(value) {
    if (!value) return '';
    const cleanedValue = value.replace(/\D/g, "");
    const match = cleanedValue.match(/^(\d{0,2})?(\d{0,3})?$/);

    return [
        match[1],
        match[2] ? " - " : '',
        match[2]
    ].join('');
}

function formatZipCodeNoPL(event) {
    if(null === event.key.match(/^[A-Za-z0-9 -]{0,10}$/)){
        event.preventDefault();
        return false;
    }
}

function convertHTML(str) {
    return str.replace(/&/g, '&amp;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;').replace(/\"/g, '&quot;').replace(/\'/g, '&apos;');
}